import { GLEngineResources } from "./engineResources.js";

export class Pipette {
    _resources: GLEngineResources;
    _active: boolean;

    constructor(resources) {
        var self = this;
        self._resources = resources;
        self._active = false;
    }

    get activated() {
        return this._active;
    }

    set active(value) {
        this._active = value;
    }

    pick(position) {
        var gl = this._resources.gl;
        var pixel = new Uint8Array(4);
        gl.readPixels(position[0], position[1], 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
        pixel[3] = 1;
        return pixel;
    }

    destroy() {

    }

}
